module.exports = __webpack_public_path__ + "static/media/logo-icon.c4f23ad6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/logo-icon.png
// module id = 502
// module chunks = 98